<pgh-modal-window size="md">
  <h4 modal-title><adp-label [labelKey]="modalData.title"></adp-label></h4>
  <p [innerHtml]="modalData.body" modal-body class="mt-25 mb-25 text-center"></p>
  <div modal-footer class="row">    
    <div class="col-6">
      <button mat-flat-button color="accent" type="button" (click)="onClose('Yes')">
        <adp-label [labelKey]="modalData.buttonEndText"></adp-label>
      </button>
    </div>
    <div class="col-6">
      <button mat-stroked-button color="accent" type="button" (click)="onClose('No')">
        <adp-label [labelKey]="modalData.buttonContinueText"></adp-label>
      </button>
    </div>
  </div>
</pgh-modal-window>
